import qs from "qs";
export function parseConfigFromQueryAction(query) {
  var _parsedQueryString$ac;
  const parsedQueryString = qs.parse(query, {
    ignoreQueryPrefix: true
  });
  const parsedConfig = (_parsedQueryString$ac = parsedQueryString.action) === null || _parsedQueryString$ac === void 0 ? void 0 : _parsedQueryString$ac.follow_campaign;
  if (!parsedConfig) return;
  return parsedConfig;
}
export function queryFromConfig(config) {
  const query = {
    action: {
      follow_campaign: config
    }
  };
  return qs.stringify(query, {
    arrayFormat: "comma"
  });
}